// extracted by mini-css-extract-plugin
export default {"title":"A6sV","tall":"RL6E"};